var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { KeyLabel } from '../../../../shared/domain/key-label.model';
import { SortUtils } from '../../../../shared/utils/sort-utils';
export var ReportMetric;
(function (ReportMetric) {
    // general
    ReportMetric["HOUR"] = "HOUR";
    ReportMetric["YEAR"] = "YEAR";
    ReportMetric["VISIT_DURATION"] = "VISIT_DURATION";
    ReportMetric["SW_CATEGORY"] = "SW_CATEGORY";
    ReportMetric["SW_SUBCATEGORY"] = "SW_SUBCATEGORY";
    ReportMetric["SW_RANK"] = "SW_RANK";
    ReportMetric["BOUNCE_RATE"] = "BOUNCE_RATE";
    ReportMetric["VISITS"] = "VISITS";
    ReportMetric["TAXONOMY"] = "TAXONOMY";
    ReportMetric["DEVICE_PLACEMENT"] = "DEVICE_PLACEMENT";
    ReportMetric["ACTIVITY_STATUS"] = "ACTIVITY_STATUS";
    ReportMetric["DEMAND_PARTNER"] = "DEMAND_PARTNER";
    ReportMetric["PUBLISHER"] = "PUBLISHER";
    ReportMetric["PUBLISHER_KICKOFFCALLDATE"] = "PUBLISHER_KICKOFFCALLDATE";
    ReportMetric["PUBLISHER_IOEXECUTEDDATE"] = "PUBLISHER_IOEXECUTEDDATE";
    ReportMetric["SITE"] = "SITE";
    ReportMetric["URL"] = "URL";
    ReportMetric["VAST_UNIT"] = "VAST_UNIT";
    ReportMetric["CONTENT_TYPE"] = "CONTENT_TYPE";
    ReportMetric["WIDGET_TYPE"] = "WIDGET_TYPE";
    ReportMetric["WIDGET_SIZE"] = "WIDGET_SIZE";
    ReportMetric["VIDEO_UNIT"] = "VIDEO_UNIT";
    ReportMetric["WIDGET"] = "WIDGET";
    ReportMetric["MONTH"] = "MONTH";
    ReportMetric["DAY"] = "DAY";
    ReportMetric["IO_CPM"] = "IO_CPM";
    ReportMetric["BIDDER"] = "BIDDER";
    ReportMetric["AD_UNIT"] = "AD_UNIT";
    ReportMetric["AD_UNIT_CUSTOM_NAME"] = "AD_UNIT_CUSTOM_NAME";
    ReportMetric["BRIDGE_AD_UNIT_CREATION_DATE"] = "BRIDGE_AD_UNIT_CREATION_DATE";
    ReportMetric["SALES_REPRESENTATIVE"] = "SALES_REPRESENTATIVE";
    ReportMetric["ACCOUNT_REPRESENTATIVE_EMAIL"] = "ACCOUNT_REPRESENTATIVE_EMAIL";
    ReportMetric["PUBLISHER_ACTIVITY_STATUS"] = "PUBLISHER_ACTIVITY_STATUS";
    ReportMetric["SITE_MANAGEMENT"] = "SITE_MANAGEMENT";
    ReportMetric["PUBLISHER_TIER"] = "PUBLISHER_TIER";
    // KPI
    ReportMetric["RPM"] = "RPM";
    ReportMetric["ECPM"] = "ECPM";
    ReportMetric["AD_IMPRESSION_RATIO"] = "AD_IMPRESSION_RATIO";
    ReportMetric["RCPM"] = "RCPM";
    ReportMetric["MARGIN"] = "MARGIN";
    ReportMetric["FILLED"] = "FILLED";
    ReportMetric["REFRESH_RATE"] = "REFRESH_RATE";
    // stats
    ReportMetric["IMPRESSIONS"] = "IMPRESSIONS";
    ReportMetric["S3_IMPRESSIONS"] = "S3_IMPRESSIONS";
    ReportMetric["IMPRESSION_CORRECTIONS"] = "IMPRESSION_CORRECTIONS";
    ReportMetric["PIXEL_IMPRESSIONS"] = "PIXEL_IMPRESSIONS";
    ReportMetric["DFP_DOWNLOADED_IMPRESSIONS"] = "DFP_DOWNLOADED_IMPRESSIONS";
    ReportMetric["FILLED_IMPRESSIONS"] = "FILLED_IMPRESSIONS";
    ReportMetric["AD_REQUESTS"] = "AD_REQUESTS";
    ReportMetric["IMPRESSION_CORRECTION_FACTOR"] = "IMPRESSION_CORRECTION_FACTOR";
    ReportMetric["WIDGET_REQUESTS"] = "WIDGET_REQUESTS";
    ReportMetric["EBDA_IMPRESSIONS"] = "EBDA_IMPRESSIONS";
    ReportMetric["CONSTANT_BID"] = "CONSTANT_BID";
    ReportMetric["OVERBID"] = "OVERBID";
    // discrepancy
    ReportMetric["REVENUE_DISCREPANCY"] = "REVENUE_DISCREPANCY";
    ReportMetric["REVENUE_DISCREPANCY_AMOUNT"] = "REVENUE_DISCREPANCY_AMOUNT";
    ReportMetric["AD_REQUEST_DISCREPANCY"] = "AD_REQUEST_DISCREPANCY";
    ReportMetric["FILLED_DISCREPANCY"] = "FILLED_DISCREPANCY";
    // financial
    ReportMetric["PROFIT"] = "PROFIT";
    ReportMetric["PUBLISHER_REVENUE"] = "PUBLISHER_REVENUE";
    ReportMetric["REVENUE"] = "REVENUE";
    ReportMetric["BIDDER_COST_FACTOR"] = "BIDDER_COST_FACTOR";
    ReportMetric["BIDDER_COST"] = "BIDDER_COST";
    ReportMetric["EBDA_REVENUE"] = "EBDA_REVENUE";
    ReportMetric["EBDA_VIDEO_REVENUE"] = "EBDA_VIDEO_REVENUE";
    ReportMetric["EBDA_VIDEO_IMPRESSIONS"] = "EBDA_VIDEO_IMPRESSIONS";
    ReportMetric["PASSBACK_REVENUE"] = "PASSBACK_REVENUE";
    ReportMetric["PUBLISHER_SHARE_REVENUE"] = "PUBLISHER_SHARE_REVENUE";
    ReportMetric["PUBLISHER_IO_REVENUE"] = "PUBLISHER_IO_REVENUE";
    ReportMetric["REVENUE_SHARE_PERCENT"] = "REVENUE_SHARE_PERCENT";
    // engagement
    ReportMetric["CTR_TOTAL"] = "CTR_TOTAL";
    ReportMetric["CTR_AD_SERVER"] = "CTR_AD_SERVER";
    ReportMetric["CTR_AD_EXCHANGE"] = "CTR_AD_EXCHANGE";
    ReportMetric["PLAYS"] = "PLAYS";
    ReportMetric["CLICKS"] = "CLICKS";
    ReportMetric["IN_VIEW"] = "IN_VIEW";
    ReportMetric["IN_VIEW_ADX"] = "IN_VIEW_ADX";
    ReportMetric["IN_VIEW_DFP"] = "IN_VIEW_DFP";
    ReportMetric["ENGAGEMENT_RELATIVE"] = "ENGAGEMENT_RELATIVE";
    ReportMetric["DISPLAY_DURATION_RELATIVE"] = "DISPLAY_DURATION_RELATIVE";
    ReportMetric["ENGAGEMENT"] = "ENGAGEMENT";
    ReportMetric["DISPLAY_DURATION"] = "DISPLAY_DURATION";
    ReportMetric["VISIBILITY"] = "VISIBILITY";
    // serverbid
    ReportMetric["SB_IMPRESSIONS"] = "SB_IMPRESSIONS";
    ReportMetric["SB_IMPRESSIONS_DISC"] = "SB_IMPRESSIONS_DISC";
    ReportMetric["SB_REVENUE"] = "SB_REVENUE";
    ReportMetric["SB_REVENUE_DISC"] = "SB_REVENUE_DISC";
    ReportMetric["SB_REQUESTS"] = "SB_REQUESTS";
    ReportMetric["SB_REQUESTS_DISC"] = "SB_REQUESTS_DISC";
    ReportMetric["SB_PARTNER_REQUESTS"] = "SB_PARTNER_REQUESTS";
    ReportMetric["SB_DOMAIN"] = "SB_DOMAIN";
    ReportMetric["SB_FIRST_IMPRESSION_REVENUE"] = "SB_FIRST_IMPRESSION_REVENUE";
    ReportMetric["SB_CONSTANT_BID_REVENUE"] = "SB_CONSTANT_BID_REVENUE";
    ReportMetric["SB_OVERBID_REVENUE"] = "SB_OVERBID_REVENUE";
    // other
    ReportMetric["USING_CONFIANT"] = "USING_CONFIANT";
    ReportMetric["EB_ASSOCIATED_PUBLISHER_ID"] = "EB_ASSOCIATED_PUBLISHER_ID";
    ReportMetric["EB_ASSOCIATED_PUBLISHER_NAME"] = "EB_ASSOCIATED_PUBLISHER_NAME";
})(ReportMetric || (ReportMetric = {}));
export var ReportMetricFormat;
(function (ReportMetricFormat) {
    ReportMetricFormat[ReportMetricFormat["STRING"] = 0] = "STRING";
    ReportMetricFormat[ReportMetricFormat["NUMBER"] = 1] = "NUMBER";
    ReportMetricFormat[ReportMetricFormat["DECIMAL"] = 2] = "DECIMAL";
    ReportMetricFormat[ReportMetricFormat["DATE_TIME"] = 3] = "DATE_TIME";
    ReportMetricFormat[ReportMetricFormat["PERCENTAGE"] = 4] = "PERCENTAGE";
    ReportMetricFormat[ReportMetricFormat["PERCENTAGE_PLAIN"] = 5] = "PERCENTAGE_PLAIN";
    ReportMetricFormat[ReportMetricFormat["CURRENCY"] = 6] = "CURRENCY";
})(ReportMetricFormat || (ReportMetricFormat = {}));
var ReportMetricDetails = /** @class */ (function (_super) {
    __extends(ReportMetricDetails, _super);
    function ReportMetricDetails(key, label, field, description) {
        var _this = _super.call(this, key, label) || this;
        _this.format = ReportMetricFormat.STRING;
        _this.field = field;
        _this.description = description;
        return _this;
    }
    ReportMetricDetails.prototype.ofFormat = function (type) {
        this.format = type;
        return this;
    };
    return ReportMetricDetails;
}(KeyLabel));
export { ReportMetricDetails };
export var ReportMetricsAll = function () { return [
    // general
    new ReportMetricDetails(ReportMetric.DAY, 'Day', 'day'),
    new ReportMetricDetails(ReportMetric.HOUR, 'Hour', 'time'),
    new ReportMetricDetails(ReportMetric.MONTH, 'Month', 'month'),
    new ReportMetricDetails(ReportMetric.YEAR, 'Year', 'year'),
    new ReportMetricDetails(ReportMetric.BRIDGE_AD_UNIT_CREATION_DATE, 'Ad unit creation date', 'bridgeAdUnitCreationDate').ofFormat(ReportMetricFormat.DATE_TIME),
    new ReportMetricDetails(ReportMetric.WIDGET, 'Placement ID', 'campaignId'),
    new ReportMetricDetails(ReportMetric.WIDGET_TYPE, 'Widget type', 'widgetName'),
    new ReportMetricDetails(ReportMetric.WIDGET_SIZE, 'Placement size', 'widgetSize'),
    new ReportMetricDetails(ReportMetric.CONTENT_TYPE, 'Content type', 'contentType'),
    new ReportMetricDetails(ReportMetric.AD_UNIT, 'Ad unit', 'bridgeAdUnitName'),
    new ReportMetricDetails(ReportMetric.AD_UNIT_CUSTOM_NAME, 'Ad unit (custom name)', 'bridgeAdUnitCustomName'),
    new ReportMetricDetails(ReportMetric.IO_CPM, 'IO CPM', 'ioCpm').ofFormat(ReportMetricFormat.CURRENCY),
    new ReportMetricDetails(ReportMetric.SITE, 'Site', 'siteName'),
    new ReportMetricDetails(ReportMetric.URL, 'Site (domain)', 'url'),
    new ReportMetricDetails(ReportMetric.PUBLISHER, 'Publisher', 'publisherName'),
    new ReportMetricDetails(ReportMetric.DEMAND_PARTNER, 'Demand Partner', 'demandPartner'),
    new ReportMetricDetails(ReportMetric.ACTIVITY_STATUS, 'Activity Status', 'activityStatus'),
    new ReportMetricDetails(ReportMetric.DEVICE_PLACEMENT, 'Device Placement', 'devicePlacement'),
    new ReportMetricDetails(ReportMetric.TAXONOMY, 'Taxonomy', 'taxonomy'),
    new ReportMetricDetails(ReportMetric.VISITS, 'Monthly visits', 'visits').ofFormat(ReportMetricFormat.NUMBER),
    new ReportMetricDetails(ReportMetric.BOUNCE_RATE, 'Bounce rate', 'bounceRate').ofFormat(ReportMetricFormat.NUMBER),
    new ReportMetricDetails(ReportMetric.SW_RANK, 'Rank', 'swRank').ofFormat(ReportMetricFormat.NUMBER),
    new ReportMetricDetails(ReportMetric.SW_SUBCATEGORY, 'Subcategory', 'swSubcategory'),
    new ReportMetricDetails(ReportMetric.SW_CATEGORY, 'Category', 'swCategory'),
    new ReportMetricDetails(ReportMetric.VISIT_DURATION, 'Average visit duration', 'visitDuration').ofFormat(ReportMetricFormat.NUMBER),
    new ReportMetricDetails(ReportMetric.SALES_REPRESENTATIVE, 'Sales representative', 'salesRepresentative').ofFormat(ReportMetricFormat.STRING),
    new ReportMetricDetails(ReportMetric.ACCOUNT_REPRESENTATIVE_EMAIL, 'Account manager', 'accountManager').ofFormat(ReportMetricFormat.STRING),
    new ReportMetricDetails(ReportMetric.BIDDER, 'Bidder', 'bidder').ofFormat(ReportMetricFormat.STRING),
    new ReportMetricDetails(ReportMetric.PUBLISHER_ACTIVITY_STATUS, 'Pub Activity Status', 'publisherActivityStatus').ofFormat(ReportMetricFormat.STRING),
    new ReportMetricDetails(ReportMetric.PUBLISHER_KICKOFFCALLDATE, 'Pub KO Date', 'publisherKickOffCallDate').ofFormat(ReportMetricFormat.STRING),
    new ReportMetricDetails(ReportMetric.PUBLISHER_IOEXECUTEDDATE, 'Pub IO Date', 'publisherIoExecutedDate').ofFormat(ReportMetricFormat.STRING),
    new ReportMetricDetails(ReportMetric.SITE_MANAGEMENT, 'Site Management', 'management').ofFormat(ReportMetricFormat.STRING),
    new ReportMetricDetails(ReportMetric.VAST_UNIT, 'Vast unit', 'vastUnit').ofFormat(ReportMetricFormat.STRING),
    new ReportMetricDetails(ReportMetric.VIDEO_UNIT, 'Video unit', 'videoUnit').ofFormat(ReportMetricFormat.STRING),
    new ReportMetricDetails(ReportMetric.PUBLISHER_TIER, 'Publisher tier', 'publisherTier').ofFormat(ReportMetricFormat.STRING),
    // kpi
    new ReportMetricDetails(ReportMetric.MARGIN, 'Margin', 'margin').ofFormat(ReportMetricFormat.PERCENTAGE),
    new ReportMetricDetails(ReportMetric.FILLED, 'Fill %', 'filled').ofFormat(ReportMetricFormat.PERCENTAGE),
    new ReportMetricDetails(ReportMetric.RPM, 'RPM', 'rpm').ofFormat(ReportMetricFormat.CURRENCY),
    new ReportMetricDetails(ReportMetric.RCPM, 'RCPM', 'rcpm').ofFormat(ReportMetricFormat.CURRENCY),
    new ReportMetricDetails(ReportMetric.ECPM, 'ECPM', 'ecpm').ofFormat(ReportMetricFormat.CURRENCY),
    new ReportMetricDetails(ReportMetric.REFRESH_RATE, 'Refresh rate', 'refreshRate').ofFormat(ReportMetricFormat.DECIMAL),
    new ReportMetricDetails(ReportMetric.AD_IMPRESSION_RATIO, 'Ad Impression Ratio', 'adImpressionRatio').ofFormat(ReportMetricFormat.DECIMAL),
    // stats
    new ReportMetricDetails(ReportMetric.IMPRESSIONS, 'Impressions', 'impressions').ofFormat(ReportMetricFormat.NUMBER),
    new ReportMetricDetails(ReportMetric.AD_REQUESTS, 'Ad requests', 'adRequests').ofFormat(ReportMetricFormat.NUMBER),
    new ReportMetricDetails(ReportMetric.EBDA_IMPRESSIONS, 'EBDA Impressions', 'dfpEbdaImpressions').ofFormat(ReportMetricFormat.NUMBER),
    new ReportMetricDetails(ReportMetric.EBDA_VIDEO_IMPRESSIONS, 'EBDA Video Impressions', 'dfpEbdaVideoImpressions').ofFormat(ReportMetricFormat.NUMBER),
    new ReportMetricDetails(ReportMetric.WIDGET_REQUESTS, 'Widget requests', 'widgetRequests').ofFormat(ReportMetricFormat.NUMBER),
    new ReportMetricDetails(ReportMetric.IMPRESSION_CORRECTION_FACTOR, 'Impr. corr. factor', 'imprCorrectionFactor'),
    new ReportMetricDetails(ReportMetric.IMPRESSION_CORRECTIONS, 'Impr. corrections', 'imprCorrections'),
    new ReportMetricDetails(ReportMetric.FILLED_IMPRESSIONS, 'Filled impressions', 'filledImpressions').ofFormat(ReportMetricFormat.NUMBER),
    new ReportMetricDetails(ReportMetric.DFP_DOWNLOADED_IMPRESSIONS, 'Dfp dwnl. impressions', 'dfpDownloadedImpressions').ofFormat(ReportMetricFormat.NUMBER),
    new ReportMetricDetails(ReportMetric.PIXEL_IMPRESSIONS, 'Pixel impressions', 'pixels').ofFormat(ReportMetricFormat.NUMBER),
    new ReportMetricDetails(ReportMetric.S3_IMPRESSIONS, 'S3 impressions', 's3Impressions').ofFormat(ReportMetricFormat.NUMBER),
    new ReportMetricDetails(ReportMetric.CONSTANT_BID, 'Constant bid ($)', 'constantBid').ofFormat(ReportMetricFormat.NUMBER),
    new ReportMetricDetails(ReportMetric.OVERBID, 'Overbid (%)', 'overbid').ofFormat(ReportMetricFormat.PERCENTAGE),
    // financial
    new ReportMetricDetails(ReportMetric.REVENUE, 'Revenue', 'revenue').ofFormat(ReportMetricFormat.CURRENCY),
    new ReportMetricDetails(ReportMetric.PROFIT, 'Profit', 'netRevenue').ofFormat(ReportMetricFormat.CURRENCY),
    new ReportMetricDetails(ReportMetric.PUBLISHER_REVENUE, 'Pub. revenue', 'publisherNetRevenue').ofFormat(ReportMetricFormat.CURRENCY),
    new ReportMetricDetails(ReportMetric.BIDDER_COST_FACTOR, 'Bidder cost factor', 'bidderCostFactor').ofFormat(ReportMetricFormat.DECIMAL),
    new ReportMetricDetails(ReportMetric.BIDDER_COST, 'Bidder cost', 'bidderCost').ofFormat(ReportMetricFormat.CURRENCY),
    new ReportMetricDetails(ReportMetric.EBDA_REVENUE, 'EBDA Revenue', 'dfpEbdaRevenue').ofFormat(ReportMetricFormat.CURRENCY),
    new ReportMetricDetails(ReportMetric.EBDA_VIDEO_REVENUE, 'EBDA Video Revenue', 'dfpEbdaVideoRevenue').ofFormat(ReportMetricFormat.CURRENCY),
    new ReportMetricDetails(ReportMetric.PASSBACK_REVENUE, 'Passback revenue', 'passbackRevenue').ofFormat(ReportMetricFormat.CURRENCY),
    new ReportMetricDetails(ReportMetric.PUBLISHER_SHARE_REVENUE, 'Pub. Share revenue', 'revShareGross').ofFormat(ReportMetricFormat.CURRENCY),
    new ReportMetricDetails(ReportMetric.PUBLISHER_IO_REVENUE, 'Pub. IO revenue', 'publisherGrossRevenue').ofFormat(ReportMetricFormat.CURRENCY),
    new ReportMetricDetails(ReportMetric.REVENUE_SHARE_PERCENT, 'Revenue share %', 'revSharePercent').ofFormat(ReportMetricFormat.PERCENTAGE),
    // engagement
    new ReportMetricDetails(ReportMetric.CTR_TOTAL, 'Ctr total', 'ctrTotal').ofFormat(ReportMetricFormat.NUMBER),
    new ReportMetricDetails(ReportMetric.CTR_AD_EXCHANGE, 'Ctr ad exchange', 'ctrAdExchange').ofFormat(ReportMetricFormat.NUMBER),
    new ReportMetricDetails(ReportMetric.CTR_AD_SERVER, 'Ctr ad server', 'ctrAdServer').ofFormat(ReportMetricFormat.NUMBER),
    new ReportMetricDetails(ReportMetric.CLICKS, 'Clicks', 'clicks', 'Number of times user clicked on CTA button (i.e. "deezer button")').ofFormat(ReportMetricFormat.NUMBER),
    new ReportMetricDetails(ReportMetric.PLAYS, 'Plays', 'plays').ofFormat(ReportMetricFormat.NUMBER),
    new ReportMetricDetails(ReportMetric.ENGAGEMENT, 'Total Engagement', 'engagement', 'Total time between click actions (play/pause)').ofFormat(ReportMetricFormat.NUMBER),
    new ReportMetricDetails(ReportMetric.ENGAGEMENT_RELATIVE, 'Engagement per Imp.', 'engagementRelative').ofFormat(ReportMetricFormat.NUMBER),
    new ReportMetricDetails(ReportMetric.IN_VIEW, 'In View', 'inView').ofFormat(ReportMetricFormat.PERCENTAGE_PLAIN),
    new ReportMetricDetails(ReportMetric.IN_VIEW_DFP, 'In View DFP', 'inViewDfp').ofFormat(ReportMetricFormat.PERCENTAGE_PLAIN),
    new ReportMetricDetails(ReportMetric.IN_VIEW_ADX, 'In View ADX', 'inViewAdx').ofFormat(ReportMetricFormat.PERCENTAGE_PLAIN),
    new ReportMetricDetails(ReportMetric.DISPLAY_DURATION, 'Display Duration', 'displayDuration').ofFormat(ReportMetricFormat.NUMBER),
    new ReportMetricDetails(ReportMetric.DISPLAY_DURATION_RELATIVE, 'Display Duration Rel.', 'displayDurationRelative').ofFormat(ReportMetricFormat.NUMBER),
    new ReportMetricDetails(ReportMetric.VISIBILITY, 'Visibility', 'visibility').ofFormat(ReportMetricFormat.NUMBER),
    // discrepancy
    new ReportMetricDetails(ReportMetric.FILLED_DISCREPANCY, 'Filled discrepancy', 'filledDiscrepancy').ofFormat(ReportMetricFormat.PERCENTAGE),
    new ReportMetricDetails(ReportMetric.REVENUE_DISCREPANCY, 'Revenue discrepancy (%)', 'revenueDiscrepancy').ofFormat(ReportMetricFormat.PERCENTAGE),
    new ReportMetricDetails(ReportMetric.REVENUE_DISCREPANCY_AMOUNT, 'Revenue discrepancy amount', 'revenueDiscrepancyAmount').ofFormat(ReportMetricFormat.CURRENCY),
    new ReportMetricDetails(ReportMetric.AD_REQUEST_DISCREPANCY, 'Ad request discrepancy', 'adRequestDiscrepancy').ofFormat(ReportMetricFormat.NUMBER),
    // serverbid
    new ReportMetricDetails(ReportMetric.SB_IMPRESSIONS, 'Serverbid impressions', 'sbImpressions').ofFormat(ReportMetricFormat.NUMBER),
    new ReportMetricDetails(ReportMetric.SB_IMPRESSIONS_DISC, 'Serverbid impressions discrepancy', 'sbImpressionsDisc').ofFormat(ReportMetricFormat.PERCENTAGE_PLAIN),
    new ReportMetricDetails(ReportMetric.SB_REVENUE, 'Serverbid revenue', 'sbRevenue').ofFormat(ReportMetricFormat.CURRENCY),
    new ReportMetricDetails(ReportMetric.SB_REVENUE_DISC, 'Serverbid revenue discrepancy', 'sbRevenueDisc').ofFormat(ReportMetricFormat.PERCENTAGE_PLAIN),
    new ReportMetricDetails(ReportMetric.SB_REQUESTS, 'Serverbid requests', 'sbRequests').ofFormat(ReportMetricFormat.NUMBER),
    new ReportMetricDetails(ReportMetric.SB_REQUESTS_DISC, 'Serverbid requests discrepancy', 'sbRequestsDisc').ofFormat(ReportMetricFormat.PERCENTAGE_PLAIN),
    new ReportMetricDetails(ReportMetric.SB_PARTNER_REQUESTS, 'Serverbid partner requests', 'sbPartnerRequests').ofFormat(ReportMetricFormat.NUMBER),
    new ReportMetricDetails(ReportMetric.SB_DOMAIN, 'Serverbid Domain', 'sbDomain').ofFormat(ReportMetricFormat.STRING),
    new ReportMetricDetails(ReportMetric.SB_FIRST_IMPRESSION_REVENUE, 'Serverbid first impression revenue', 'sbFiCost').ofFormat(ReportMetricFormat.CURRENCY),
    new ReportMetricDetails(ReportMetric.SB_CONSTANT_BID_REVENUE, 'Serverbid constant bid revenue', 'sbCost').ofFormat(ReportMetricFormat.CURRENCY),
    new ReportMetricDetails(ReportMetric.SB_OVERBID_REVENUE, 'Serverbid overbid revenue', 'sbBidIncrementRevenue').ofFormat(ReportMetricFormat.CURRENCY),
    // other
    new ReportMetricDetails(ReportMetric.USING_CONFIANT, 'Confiant', 'usingConfiant'),
    new ReportMetricDetails(ReportMetric.EB_ASSOCIATED_PUBLISHER_ID, 'EB Associated Publisher Id', 'ebAssociatedPublisherId'),
    new ReportMetricDetails(ReportMetric.EB_ASSOCIATED_PUBLISHER_NAME, 'EB Associated Publisher', 'ebAssociatedPublisherName'),
].sort(SortUtils.propertyComparatorString('label')); };
export var ReportMetricsDetailsMap = function () { return ReportMetricsAll().reduce(function (prev, curr) {
    prev[curr.key] = curr;
    return prev;
}, {}); };
var ɵ0 = function (prev, curr) {
    prev[curr.key] = curr.label;
    return prev;
};
export var ReportMetricLabels = Object.freeze(ReportMetricsAll().reduce(ɵ0, {}));
export { ɵ0 };
